'use client';

import { FC, useCallback } from 'react';
import { useUnit } from 'effector-react';
import { EmojiClickData } from 'emoji-picker-react';
import { Button, ButtonType } from '@nx-frontend/shared/ui/button';
import { $ModalStore, closeModalEvent } from '@nx-frontend/shared/ui/modal';
import { EmojiSelector } from '@nx-frontend/shared/components';
import { PopupPayload, EmojiPopupPayload, PopupType } from '@nx-frontend/shared/types';

const getEmojiPopupPayload = (payload: PopupPayload | undefined): EmojiPopupPayload | null => {
  if (payload && payload.payloadType === PopupType.EMOJI) {
    return payload;
  }
  return null;
};

export const EmojiPopup: FC = () => {
  const [modalStore, closeModal] = useUnit([$ModalStore, closeModalEvent]);

  const modal = modalStore.find((m) => m.content === PopupType.EMOJI);
  const payload = getEmojiPopupPayload(modal?.payload);
  const onApply = payload?.onApply;

  const onEmojiSelect = useCallback(
    (value: EmojiClickData) => {
      if (onApply) {
        onApply(value.imageUrl);
      }
      closeModal();
    },
    [onApply, closeModal]
  );

  const onRemoveClick = useCallback(() => {
    if (onApply) {
      onApply('');
    }
    closeModal();
  }, [onApply, closeModal]);

  const renderRemoveButton = !(payload && 'allowRemove' in payload && !payload.allowRemove);

  return (
    <div
      className={`image-picker-modal flex items-center flex-wrap justify-between w-[300px] h-[45vh] ${
        renderRemoveButton ? 'allow-remove' : ''
      }`}
    >
      {renderRemoveButton && (
        <Button type={ButtonType.FLAT} onClick={onRemoveClick} className="order-2 max-w-[30%]">
          Remove
        </Button>
      )}
      <EmojiSelector onEmojiSelect={onEmojiSelect} />
    </div>
  );
};
